import { combineReducers } from 'redux';
import { pfValues, protectiveFactorsForPositional, pfValuesForSwingTrade, checkSymbolExist, pfValuesForOptions } from '../constant'

import firebase from 'firebase/app'
import 'firebase/auth';
import 'firebase/firestore';

const filterItems = (needle, heystack) => {
  let query = needle.toLowerCase()
  return heystack.filter( item => item.sym.toLowerCase().indexOf(query) >= 0 )
}

const initialState = {
  isUserLogin: false,
  loading: true,
  isUserHasAlertFeature: true,
  expiryMonths: [],
  currentPhaseLoading: false,
  intradaySelectedTab: 0,
  positionalSelectedTab: 0,
  advancedIntradaySelectedTab: 0,
  advancedPositionalSelectedTab: 0,
  optionsOnlyTabsSelectedTab: 0,
  isSmallScreen: false,
  protectiveFactors: pfValues,
  protectiveFactorsForPositional: protectiveFactorsForPositional,
  pfValuesForSwingTrade: pfValuesForSwingTrade,
  pfValuesForOptions: pfValuesForOptions,
  planExpiryDate: '',
  newConstants: [ 0.378000, 0.597500, 0.763500, 0.979050, 0.460000 ],
  newConstFrActEntry: [ 0.33200, 0.898 ],
  
  // newConstForPositional: [ 0.484, 0.765, 0.978, 1.255, 0.650 ], Old values
  newConstForPositional: [ 0.502, 0.793, 1.015, 1.300, 0.650 ],
  
  // constForConfEntryPositional: [ 0.2135 ], Old value
  // constForConfEntryPositional: [ 0.2400 ],
  constForConfEntryPositional: [ 0.2470 ],

  newConstForAdvIntraday: [ 0.502, 0.793, 1.015, 1.300, 0.650 ],
  constForConfEntryAdvIntraday: [ 0.2470 ],

  // newConstForSwingTrade: [0.500, 0.790, 1.000, 1.273, 0.612],
  newConstForSwingTrade: [ 0.560, 0.890, 1.130, 2.350, 0.760 ],
  newConstConfEntryForSwingTrade: [ 0.210 ],

  newConstForOptions: [ 0.500, 0.810, 1.050, 2.095, 0.760 ],
  newConstConfEntryForOptions: [ 0.200 ],
  // { name: "Options", key: "op" }
  instrumentsNameAndKey: [ { name: "Equity", key: 'eq' }, { name: "Futures", key: "fut" }, { name: "Options", key: "op" } ],
  optionsNameAndKey: [ { name: "Options", key: "op" } ],
  exchanges: [ "NSE" ],
  timeIntervals: [ "09:01", "09:16", "09:21","09:26", "09:31", "09:36", "09:41", "09:46", "09:51", "09:56", "10:01", "10:11", "10:16", "10:21", "10:26", "10:31", "10:36", "10:41", "10:46", "10:51" , "10:56", "11:01", "11:06", "11:11", "11:16", "11:21", "11:26", '11:31', "11:36" , "11:41", '11:46' , "11:51", "11:56", '12:01', "12:06" , '12:11', "12:16", "12:21", "12:26", '12:31', "12:36", "12:41", '12:46', "12:51", "12:56", '13:01', '13:06', '13:11', '13:16', '13:21', '13:26', '13:31', '13:36' , '13:41', '13:46', '13:51', '13:56', '14:01', '14:06', '14:11', '14:16', '14:21', '14:26', '14:31', '14:36', '14:41', '14:46' , '14:51', '14:56', '15:01', '15:06', '15:11', '15:16', '15:21', '15:26', '15:31' ],
  candleIntervals: [ '15mins', '30mins', '60mins' ],
  advancedPositionalTabs: [],
  advancedIntradayTabs: [],
  positionalTabs: [],
  intraDayTabs: [],
  optionsOnlyTabs: [],
  darkMode: false,
  allBorderColorsInDarkMode: '#808080',
  allBorderColorsInLightMode: '#c9c9c9c7',
  tabColorsInLightMode: '#808080',
  selectedTabColorsInLightMode: '#000000',
  tabColorsInDarkMode: '#f5f5f5a6',
  selectedTabColorsInDarkMode: '#ffffff',
  sideHeadingColor: "#3b98c0",
  name: '',
  loadingStatusWhenAddingTab: false,

  // truedataCreds
  userName: "tdwsp149",
  password: "vinayak@149",
  port: 8082,

  symbols: [],
  symbolsListAppearInForm: []
}

function initFunction(state = initialState, action) {
    var type = action.type;
    var payload = action.payload
    
    if(type === 'userLoginSwitch') {
      state.isUserLogin = payload
      return state;
    }
    if(type === 'setSymbols') {
      state.symbolsListAppearInForm = action.data
      return state
    }
    if(type === 'setCurrentExpiryMonth') {
      state.expiryMonths = action.data
      return state;
    }
    if(type === 'changeCurrentPhaseSwing') {
      state[action.arrayName][action.index]['swingChange'] = payload
      state[action.arrayName][action.index]['dateTwo'] = action.date
      return state;
    }
    if(type === 'addSymbols') {
      state.symbols = action.data
      state.symbolsCopy = action.data
      return state;
    }
    if(type == "loading") {
      state.loading = payload;
      return state;
    }
    if(type === "turnOnROffNotification") {
      state[action.arrayName][action.index]['notify'] = !state[action.arrayName][action.index]['notify']
      return state;
    }
    if(type === 'isSmallScreen') {
      state.isSmallScreen = payload
      return state;
    }
    if(type === 'switchDarkMode') {
      state.darkMode = action.payload.value
      state.name = action.payload.name
      state.planExpiryDate = action.payload.date
      state.startDate = action.payload.startDate
      state.plan = action.payload.plan
      return state;
    }
    if(type === 'updateInitialLastCloseValue') {
      state[action.arrayName][action.selectedTabIndex].initialLastCloseValue = action.data
      return state;
    }
    if(type === 'pushDataToTabs') {
      state[action.arrayName].push(payload)
      return state;
    }
    if(type === 'pushStockData') {
      state[action.arrayName][action.index]['data'] = action.data
      state[action.arrayName][action.index]['initialLastCloseValue'] = action.data[9]['close']
      return state;
    }
    if(type === "changeInterval") {
      state[action.arrayName][action.index]['interval'] = action.value
      return state;
    }
    if( type === "addNewTab" ) {
      let data = action.data
      state[action.arrayName].push(data)

      return {
        ...state,
        [action.arrayName]: state[action.arrayName],
        [action.selectedTabName]: state[action.arrayName].length === 1 ? 0 : state[action.arrayName].length - 1
      };
    }
    if(type === 'setCloseVerify') {
      state[action.arrayName][action.index]['closeVerify'] = payload
      return state
    }
    if(type === 'deleteTab') {
      state[action.arrayName].splice(action.tabIndex, 1)
      window.location.reload()

      // if (state[action.selectedTabName] !== 0) {
      //   return {
      //     ...state,
      //     selectedTabName: state[action.selectedTabName] - 1,
      //     [action.arrayName]: state[action.arrayName]
      //   }
      // }

      // return {
      //   ...state,
      //   [action.arrayName]: state[action.arrayName]
      // }
    }
    if(type === 'instrumentChange') {
      state[action.arrayName][action.index]['inst'] = action.data
      return state;
    }    
    if(type === 'expiryChange') {
      state[action.arrayName][action.index]['expiry'] = action.data
      return state;
    }
    if(type === 'exchangeChange') {
      state[action.arrayName][action.index]['exchange'] = action.data
      return state;
    }
    if(type === 'changeExpiryDate') {
      state[action.arrayName][action.index]['expDate'] = action.data
      return state;
    }
    if(type === 'changeSymbol') {
      state[action.arrayName][action.index]['symbol'] = action.data
      return state;
    }
    if(type === 'changeCaptionName') {
      state[action.arrayName][action.index]['labelName'] = action.data
      return state;
    }
    if(type === 'changeEndDate') {
      state[action.arrayName][action.index]['endDate'] = action.data
      return state;
    }
    if(type === 'changeSwingType') {
      state[action.arrayName][action.index]['swingType'] = action.data
      return state;
    }
    if(type === 'changeEndTime') {
      state[action.arrayName][action.index]['endTime'] = action.data
      return state;
    }
    if(type === 'setPhase') {
      state[action.arrayName][action.index]['whichPhase'] = action.data
      return state;
    }
    if(type === 'setPhaseValue') {
      state[action.arrayName][action.index][action.phaseName] = []
      state[action.arrayName][action.index]['whichPhase'] = ''
      return state
    }
    if(type === 'removeLastElementInPhaseVale') {
      state[action.arrayName][action.index][action.phaseName].pop()
      if(state[action.arrayName][action.index][action.phaseName]['length'] == 0) {        
        state[action.arrayName][action.index]['whichPhase'] = ''
      }
      return state;
    }
    if(type === 'updatePhaseValues') {
      state[action.arrayName][action.index][action.phaseName].push(action.data)
      return state;
    }
    if(type === "hideOrDisplayElement") {
      state[action.arrayName][action.index][action.elementName] = !state[action.arrayName][action.index][action.elementName]
      return state;
      // return {
      //   ...state,

      // }
    }
    if(type === "onlyDisplayElement") {
      state[action.arrayName][action.index][action.elementName] = false
      return state;
    }
    if(type === "switchTabs") {
      state[action.keyName] = action.index
      return state;
    }
    if (type === 'initPhaseCalc') {
      state[action.arrayName][action.index].initPhase = payload
      return state;
    }
    if(type === 'currentPhaseCalc') {
      state[action.key][action.index].currentPhase = payload
      return state;
    }
    if(type === "updateInitPhaseCalcPositional") {
      state.positionalTabs[action.index].initPhase = payload
      return state;
    }
    if (type === 'orderPhaseCalc') {
      state[action.arrayName][action.index].orderPlaceMentBuy = payload['buy']
      state[action.arrayName][action.index].orderPlaceMentSell = payload['sell']
      return state;
    }
    if ( type === "updateOrderPlacementCalcPositional" ) {
      state.positionalTabs[action.index].orderPlaceMentBuy = payload['buy']
      state.positionalTabs[action.index].orderPlaceMentSell = payload['sell']
      return state;
    }
    if (type === 'additionalDataCalc') {
      state[action.arrayName][action.index].additionalDetails = payload
      return state;
    }
    if(type === "updateAdditionalDataCalcPositional") {
      state.positionalTabs[action.index].additionalDetails = payload
      return state;
    }
    if(type === 'updateLastCloseValue') {
      state[action.key][action.index].data[9]['close'] = action.value
      return state
    }
    if(type === "updateTabDataInDB") {
      state[action.arrayName][action.selectedTabIndex] = action.payload
      return state
    }
    if(type === "setCurrentPhaseLoadingForTab") {
      state[action.categoryName][action.tabIndex]['currentPhaseLoading'] = action.loadingStatus;
      return state;
    }
    if (type === "setSwing") {
      state[action.arrayName][action.index].latestSwing = payload
      state[action.arrayName][action.index].swing = payload
      state[action.arrayName][action.index].swingVal = action.swingVal
      state[action.arrayName][action.index].data[9]['close'] = action.swingVal
      return state;
    }
    if (type === "setSwingPositional") {
      state.positionalTabs[action.index].swing = payload
      state.positionalTabs[action.index].swingVal = action.swingVal
      state.positionalTabs[action.index].data[9]['close'] = action.swingVal
      return state;
    }
    if(type === "setCandleData") {
      state[action.arrayName][action.selectedTabIndex]['candleData'] = action.data
      return state
    }
    if(type === "setHeikenashiClose") {
      state[action.arrayName][action.selectedTabIndex]['data'][action.index].close = action.value
      return state;
    }
    if(type === "setCorrectionCandleDetails" ) {
      state[action.key][action.index]['correctionCandleData'] = payload
      return state
    }
    if(type === 'currentPhaseLoading') {
      state.currentPhaseLoading = action.loading
      return state
    }
    if(type === 'latestSwing') {
      state[action.arrayName][action.index]['latestSwing'] = action.payload
      return state
    }
    if(type === 'setStopCalc') {
      state["intraDayTabs"][state.intradaySelectedTab]['stopCalc'] = action.payload
      return state
    }
    if(type === 'setEndDate') {
      state["intraDayTabs"][state.intradaySelectedTab]['endCandleDate'] = action.payload
      return state
    }
    if(type === "symbolFilter") {
      let keyLength = action.key.length 
      state.symbol = action.key

      if(keyLength < state.symbolKeyLength) {
          state.symbols = state.symbolsCopy
      }

      state.symbols = filterItems(state.symbol, state.symbolsCopy);
      state.symbolKeyLength = keyLength

      return state
    }
    if(type === "deleteOptionSymbol") {
      const db = firebase.firestore()
      const symbolDocRef = db.collection('symbolsNew').doc("listOfSymbols")

      symbolDocRef.update({
        "symbols": firebase.firestore.FieldValue.arrayRemove(action.payload)
      })
      .then((_) => {
        console.log('Chk', action);
        window.location.reload()
        return state
      })
      .catch((err) => {
        console.log('Error', 'Error from deleteOptionSymbol', err);
        return state
      })
    }
    if(type === "addNewSymbol") {
      checkSymbolExist(action.data, function(symExist) {
        if(symExist) {
          let db = firebase.firestore()
          // let symbolDocRef = db.collection('symbols').doc("listOfSymbols")
          let symbolDocRef = db.collection('symbolsNew').doc("listOfSymbols")
          
          state.symbolsCopy.push(action.data)
          state.symbols.push(action.data)

          symbolDocRef.update({
              "symbols": state.symbolsCopy
          }).then(_ => {
            alert("Symbol added")
            window.location.reload()
          })

          return state
        }
      })
  }

  return state
}

const reducer =  combineReducers({
    initFunction: initFunction
});

export default reducer;